"use client";

import Image from "next/image";
import Link from "next/link";

import { Breadcrumb, Button, Skeleton, Text } from "@aprosoja/ui";
import { AdvertisingBanner, CardNews } from "@aprosoja/containers";
import { useMediaQuery } from "@aprosoja/hooks";
import { handleLimitCharacter } from "@aprosoja/utils";

import useCategory from "./use-category";
import NewsCreationInfo from "../complete-news/components/news-creation-info";

interface PageProps {
  params: {
    slug: string;
  };
}

const Category = ({ params }: PageProps) => {
  const {
    newsData,
    loadMore,
    categoryData,
    firstRecentNews,
    newsDataIsLoading,
    remainingRecentNews,
    categoryDataIsLoading,
  } = useCategory(params.slug);
  const isTabletSmall = useMediaQuery("(min-width: 744px)");

  const segments = [
    { label: "Notícias", path: "noticias" },
    {
      label: `${handleLimitCharacter(categoryData?.name, 50)}`,
      path: `${categoryData?.slug}`,
    },
  ];

  return (
    <div
      className="flex flex-col gap-size-x10 tabletMedium:gap-size-x20 max-w-[1560px] py-size-x10 tabletSmall:py-size-x14 desktopLarge:py-size-x20
    mx-auto px-size-x4 tabletMedium:px-size-x10 "
    >
      <AdvertisingBanner type="top" />
      <div className="flex flex-col w-full gap-size-x9">
        <Breadcrumb segments={segments} />
        {categoryDataIsLoading || !categoryData ? (
          <Skeleton className="bg-neutral-300 w-full h-size-x14" />
        ) : (
          <Text type="headingL">{categoryData?.name}</Text>
        )}
        <div>
          {newsDataIsLoading ||
          !firstRecentNews ||
          !firstRecentNews[0]?.category ? (
            <Skeleton className="bg-neutral-300 w-full h-[1060px]" />
          ) : (
            <Link
              href={`/noticias/${firstRecentNews[0].slug}`}
              className="flex flex-col gap-size-x4"
            >
              <div className="relative flex w-full h-[277px] tabletSmall:w-[650px] tabletLarge:w-[900px] tabletSmall:h-[327px] rounded-border-radius-small tabletMedium:h-[506px] mx-auto">
                <Image
                  className="object-cover rounded-border-radius-small"
                  src={firstRecentNews[0].imageUrl ?? ""}
                  alt="imagem-noticia"
                  fill
                />
              </div>
              <NewsCreationInfo
                authorName={firstRecentNews[0]?.author?.name ?? ""}
                categoryName={firstRecentNews[0]?.category?.name ?? ""}
                createdAt={firstRecentNews[0]?.createdAt ?? ""}
              />
              <Text type="headingM">{firstRecentNews[0]?.title}</Text>
            </Link>
          )}
        </div>
        <div className="w-full justify-center flex flex-col gap-size-x8 ">
          {(newsDataIsLoading &&
            [1, 2].map((index) => (
              <Skeleton
                key={index}
                className="bg-neutral-300 w-full h-[289px]"
              />
            ))) ||
            (remainingRecentNews.length > 0 &&
              remainingRecentNews?.map((news) => (
                <CardNews
                  hasImage
                  key={news.id}
                  data={news}
                  orientation={isTabletSmall ? "horizontal" : "vertical"}
                  variant="default"
                />
              ))) || <></>}
        </div>
        {newsData && newsData?.total >= newsData.limit && (
          <Button
            variant="outlined"
            size="large"
            color="primary"
            className="w-full rounded-border-radius-small"
            onClick={() => loadMore()}
          >
            Ver mais
          </Button>
        )}
      </div>
    </div>
  );
};

export default Category;
